<template>
  <div class="create-tracking-category-popup">
    <colored-popup :class="variant" :close-action="close">

      <template v-slot:top-content>
        <div class="title">
          הוספת קטגוריה למעקב
        </div>
      </template>

      <template v-slot:bottom-content>
        <div class="question">אחרי מה לעקוב?</div>
        <cashflow-category-dropdown :options="availableTrackingCategories"
                  :first-selected="selectedTrackingCategory"
                  :on-select="selectTrackingCategory" />
        <riseup-button :action="onSave"
                       :variant="'primary'"
                       :title="'המשך'"
                       :disabled="!selectedTrackingCategory"/>
      </template>

    </colored-popup>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../../../Segment';
import cashflowViewConsts from '../../../../../../../../../../constants/cashflow-view';

export default {
  name: 'CreateTrackingCategoryPopup',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    CashflowCategoryDropdown: BaseUI.CashflowCategoryDropdown,
    RiseupButton: BaseUI.RiseupButton,
  },
  created() {
    Segment.trackUserInteraction('CreateTrackingCategory_Entered', {});
  },
  computed: {
    ...mapState('createTrackingCategory', ['selectedTrackingCategory']),
    ...mapGetters('createTrackingCategory', ['availableTrackingCategories']),
    variant() {
      return cashflowViewConsts.CATEGORY_STYLE[cashflowViewConsts.CASHFLOW_CATEGORIES.TRACKING];
    },
  },
  methods: {
    ...mapActions('createTrackingCategory', ['selectTrackingCategory', 'reset']),
    close() {
      this.reset();
      Segment.trackUserInteraction('CreateTrackingCategory_CloseClicked', {});
      this.$emit('close');
    },
    onSave() {
      Segment.trackUserInteraction('CreateTrackingCategory_SaveClicked', {
        selectedTrackingCategory: this.selectedTrackingCategory,
        availableTrackingCategories: this.availableTrackingCategories,
      });
      this.$emit('done-clicked');
    },
  },
};
</script>

<style lang="scss">
  @import '~base-ui/src/scss/riseup-colors';

  .create-tracking-category-popup {
    text-align: right;

    .colored-top {
      color: $riseup_white;

      .title {
        font-size: 24px;
        font-weight: bold;
      }
    }

    .bottom {
      .question {
        margin-bottom: 13px;
        font-weight: bold;
      }

      .cashflow-category-dropdown {
        margin-bottom: 40px;
      }

      .riseup-button {
        width: 100%;
      }
    }
  }

</style>
